module.exports = __webpack_public_path__ + "img/newInt-rs-assess.5b5923d9.svg";